import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/gci/business-assistants/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}gci/business-assistants/delete`,
        endpoint: config.endpoints.backend + 'gci/business-assistants/getall',
        endpointGetAllCompanies: config.endpoints.backend + 'gci/companies/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Assistentes Administrativos',
        labelTitleButtonAdd: 'Incluir novo Assistente Administrativo',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        formFilters: !profileFilter.gci_company_id ? filters : null,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'name',
                label: 'Nome do Usuário'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
